










import Vue from 'vue'
import LoadingIndicator from './LoadingIndicator.vue'
import SlideControl from './SlideControl.vue'

export default Vue.extend({
  props: {
    option: Object
  },
  components: {
    LoadingIndicator,
    SlideControl
  }
})
